import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, Spinner, FormGroup, Input,
  Badge, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap'
import moment from 'moment'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import Select from '../../../components/Template/Input/Select'
import DataTable from '../../../components/Template/Table/DataTable'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import { notifyError } from '../../../utils/notify'
import {
  getPurchAndMaintenanceSolicitations, postPurchAndMaintenanceSolicitation,
} from '../../../store/ducks/patrimony'

const priorities = [
  {
    label: '(1) Alta',
    value: '(1) Alta',
  },
  {
    label: '(2) Normal',
    value: '(2) Normal',
  },
  {
    label: '(3) Baixa',
    value: '(3) Baixa',
  },
]

const sectors = [
  {
    label: 'Técnico',
    value: 'Técnico',
  },
  {
    label: 'Administrativo',
    value: 'Administrativo',
  },
  {
    label: 'Comercial Público',
    value: 'Comercial Público',
  },
  {
    label: 'Comercial Privado',
    value: 'Comercial Privado',
  },
  {
    label: 'Diretoria',
    value: 'Diretoria',
  },
]

class PurchAndMaintenanceSolicitations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addSolicitationModalIsOpen: false,
      subject: '',
      subjectInputError: '',
      priority: '',
      priorityInputError: '',
      sector: '',
      sectorInputError: '',
      description: '',
      descriptionInputError: '',
      value: '',
      valueInputError: '',
      payment: '',
      paymentInputError: '',
    }
  }

  componentDidMount() {
    const { getPurchAndMaintenanceSolicitations } = this.props

    getPurchAndMaintenanceSolicitations()
  }

  componentDidUpdate(prevProps) {
    const { getPurchAndMaintenanceSolicitations } = this.props
    const { postPurchAndMaintenanceSolicitationIsLoading, postPurchAndMaintenanceSolicitationSuccess } = this.props.patrimony

    if (
      prevProps.patrimony.postPurchAndMaintenanceSolicitationIsLoading !== postPurchAndMaintenanceSolicitationIsLoading
      && !postPurchAndMaintenanceSolicitationIsLoading
      && postPurchAndMaintenanceSolicitationSuccess
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ addSolicitationModalIsOpen: false })
      getPurchAndMaintenanceSolicitations()
    }

    return true
  }

  formatStatus = status => {
    switch (status) {
      case 'Em análise':
        return <Badge className="badge-soft-info mr-1">{status}</Badge>
      case 'Em aquisição':
        return <Badge className="badge-soft-warning mr-1">{status}</Badge>
      case 'Concluído':
        return <Badge className="badge-soft-success mr-1">{status}</Badge>
      case 'Sem solução':
        return <Badge className="badge-soft-danger mr-1">{status}</Badge>
      default:
        return status
    }
  }

  toggleModal = () => {
    const { postPurchAndMaintenanceSolicitationIsLoading } = this.props.patrimony

    if (postPurchAndMaintenanceSolicitationIsLoading) return null

    this.setState(prevState => ({
      addSolicitationModalIsOpen: !prevState.addSolicitationModalIsOpen,
    }))

    return null
  }

  handleSubmit = () => {
    const { postPurchAndMaintenanceSolicitation } = this.props
    const { subject, priority, sector, description, value, payment } = this.state

    if (!subject) this.setState({ subjectInputError: 'Campo obrigatório.' })
    //if (!priority) this.setState({ priorityInputError: 'Campo obrigatório.' })


    if (!description) this.setState({ descriptionInputError: 'Campo obrigatório.' })

    if (!value) {
      notifyError('Preencha o campo de valor')
      return
    }

    if (subject && value && description) {
      postPurchAndMaintenanceSolicitation({
        subject,
        priority,
        sector,
        description,
        value,
        payment,
      })
    }

    return null
  }

  render() {
    const {
      getPurchAndMaintenanceSolicitationsIsLoading,
      purchAndMaintenanceSolicitations,
      postPurchAndMaintenanceSolicitationIsLoading,
    } = this.props.patrimony

    const {
      addSolicitationModalIsOpen, subject, subjectInputError,
      priorityInputError, sectorInputError, description, descriptionInputError, value, valueInputError, payment, paymentInputError,
    } = this.state

    return (
      <div className="page-content">
        <Modal
          centered
          isOpen={addSolicitationModalIsOpen}
          toggle={() => this.toggleModal()}
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            Solicitar aquisição ou reparo
          </ModalHeader>
          <ModalBody>
            {/*<FormGroup>
              <Label>Prioridade</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={false}
                placeholder="Prioridade"
                options={priorities || []}
                onChange={priority => {
                  this.setState({
                    priority,
                    priorityInputError: '',
                  })
                }}
              />
              {priorityInputError && <span style={{ color: 'red' }}>{priorityInputError}</span>}
              </FormGroup>*/}
            <FormGroup>
              <Label>Setor</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={false}
                placeholder="Setor"
                options={sectors || []}
                onChange={sector => {
                  this.setState({
                    sector,
                    sectorInputError: '',
                  })
                }}
              />
              {sectorInputError && <span style={{ color: 'red' }}>{sectorInputError}</span>}
            </FormGroup>
            <FormGroup>
              <Label>Assunto</Label>
              <Input
                className="form-control"
                type="text"
                value={subject}
                onChange={e => this.setState({
                  subject: e.target.value,
                  subjectInputError: '',
                })}
              />
              {
                subjectInputError
                && (
                  <span style={{ color: 'red' }}>
                    {subjectInputError}
                  </span>
                )
              }
            </FormGroup>
            <FormGroup>
              <Label>Descrição</Label>
              <Input
                className="form-control"
                type="textarea"
                value={description}
                onChange={e => this.setState({
                  description: e.target.value,
                  descriptionInputError: '',
                })}
              />
              {
                descriptionInputError
                && (
                  <span style={{ color: 'red' }}>
                    {descriptionInputError}
                  </span>
                )
              }
            </FormGroup>
            <FormGroup>
              <Label>
                Valor
              </Label>
              <MaskedInput
                unmask
                inputRef={el => this.inputVlrGlobal = el}
                mask="R$ num"
                blocks={{
                  num: {
                    mask: Number,
                    scale: 2, // digits after point 0 for integers
                    signed: false, // disallow negative
                    thousandsSeparator: '.', // any single char
                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                    normalizeZeros: false, // appends or removes zeros at ends
                    radix: ',', // fractional delimiter
                    min: 0,
                    max: 1000000000,
                  },
                }}
                lazy={false}
                value={value}
                onAccept={e => this.setState({
                  value: e,
                  valueInputError: '',
                })}
              />
              {
                valueInputError
                && (
                  <span style={{ color: 'red' }}>
                    {valueInputError}
                  </span>
                )
              }
            </FormGroup>
            <FormGroup>
              <Label>Forma de Pagamento</Label>
              <Input
                className="form-control"
                type="textarea"
                value={payment}
                onChange={e => this.setState({
                  payment: e.target.value,
                  paymentInputError: '',
                })}
              />
              {
                paymentInputError
                && (
                  <span style={{ color: 'red' }}>
                    {paymentInputError}
                  </span>
                )
              }
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.toggleModal()}
              color="light"
              className="waves-effect"
              disabled={postPurchAndMaintenanceSolicitationIsLoading}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handleSubmit()}
              disabled={postPurchAndMaintenanceSolicitationIsLoading}
            >
              Enviar
              {postPurchAndMaintenanceSolicitationIsLoading && (
                <Spinner size="sm" className="ml-2" />
              )}
            </Button>
          </ModalFooter>
        </Modal>

        <Container fluid>
          <Breadcrumbs
            title="Aquisição/Manutenção de Equipamentos"
            breadcrumbItems={[]}
          />

          <Row>
            <Col>
              <h4>
                Lista
              </h4>
            </Col>

            <Col style={{ textAlign: 'right' }}>
              <Button
                color="primary"
                type="button"
                onClick={() => this.toggleModal()}
              >
                Solicitar
              </Button>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardBody>
                  {getPurchAndMaintenanceSolicitationsIsLoading && (
                    <Row>
                      <Col className="d-flex align-items-center justify-content-center py-3">
                        <Spinner size="sm" />
                      </Col>
                    </Row>
                  )}

                  {!getPurchAndMaintenanceSolicitationsIsLoading && purchAndMaintenanceSolicitations && (
                    <DataTable
                      data={{
                        columns: [
                          {
                            label: 'ID',
                            field: 'id',
                          },
                          {
                            label: 'Data de solicitação',
                            field: 'createDt',
                            sort: 'disabled',
                          },
                          /*{
                            label: 'Prioridade',
                            field: 'priority',
                            sort: 'disabled',
                          },*/
                          {
                            label: 'Setor',
                            field: 'sector',
                            sort: 'disabled',
                          },
                          {
                            label: 'Assunto',
                            field: 'subject',
                            sort: 'disabled',
                          },
                          {
                            label: 'Descrição',
                            field: 'description',
                            sort: 'disabled',
                          },
                          {
                            label: 'Valor',
                            field: 'value',
                            sort: 'disabled',
                          },
                          {
                            label: 'Status',
                            field: 'status',
                            sort: 'disabled',
                          },
                        ],
                        rows: purchAndMaintenanceSolicitations.map(row => ({
                          id: Number(row.fields.id),
                          createDt: moment(row.fields.Created).format('DD/MM/YYYY'),
                          //priority: row.fields.Priority,
                          sector: row.fields.Setor,
                          subject: row.fields.Title,
                          description: row.fields.Detalhamento,
                          value: currencyFormatter.format(row.fields.Valor),
                          status: this.formatStatus(row.fields.Status),
                        })),
                      }}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ patrimony: state.patrimony })
const mapDispatchToProps = dispatch => bindActionCreators({
  getPurchAndMaintenanceSolicitations,
  postPurchAndMaintenanceSolicitation,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(PurchAndMaintenanceSolicitations)
